import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FarmService } from 'src/app/services/farm-service.service';
import { ProcessService } from 'src/app/services/process.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import Swal from 'sweetalert2';
// import * as moment_tz from 'node_modules/moment-timezone';


declare var $: any;

@Component({
  selector: 'smart-config-plot',
  templateUrl: './config-plot.component.html',
  styleUrls: ['./config-plot.component.scss']
})
export class ConfigPlotComponent implements OnInit {

  constructor(
    
  ) {
  
  }

  ngOnInit(): void {
  
  }

  
}
